import { useMemo, type ReactElement } from 'react';

import { ArrowUpIcon } from '@bestseller-bit/frontend-community.theme.buying-theme';
import { SortingDirections } from '@buying/library';
import { useTheme } from '@mui/material/styles';

interface SortingIconProps {
    sorting: false | SortingDirections;
    rightAligned: boolean;
    iconSize: number;
}

const SortingIcon = ({
    sorting,
    rightAligned,
    iconSize,
}: SortingIconProps): ReactElement => {
    const { palette } = useTheme();

    const transform = useMemo(() => {
        if (!sorting) return '';
        return sorting === SortingDirections.asc
            ? 'rotate(0deg)'
            : 'rotate(180deg)';
    }, [sorting]);

    return (
        <ArrowUpIcon
            className="sort-icon"
            size={iconSize}
            style={{
                transform,
                transition: 'all 0.2s ease-in-out',
                color: sorting ? palette.text.primary : 'transparent',
                flexShrink: 0,

                ...(rightAligned && {
                    position: 'absolute',
                    right: 0,
                }),
            }}
        />
    );
};

export { SortingIcon };
